import { v1ApiClient } from '@/services';
import type { OperationPathParams } from '@/shared/api/generated';

import type { Issue } from '../model/types';

type GetIssueListParams = Partial<OperationPathParams<'RetrieveIssues'>>;
// NOTE: 실제 응답에 severity, reason 포함 — Schema에 미정의이므로 Issue 타입 사용
type GetIssueListResponse = Issue[];
type GetIssueListFunction = (
  params?: GetIssueListParams,
) => Promise<GetIssueListResponse>;

/**
 * 이슈 목록 조회
 */
export const getIssueList: GetIssueListFunction = (params) =>
  v1ApiClient
    .get(`/workspaces/${params?.workspace_id}/issues`)
    .then((res) => res.data);
